module.exports={author:"Forrest Gander",date:"7/28/2021",publishDate:"7/28/2021",highlighted:!1,tags:"",badge:"",title:"But the Rest"};